import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
    return twMerge(clsx(inputs));
}

/** Shared dark-theme rich-text styling for CMS HTML (extend per use with cn()). */
export const PROSE_INVERT =
    'prose prose-invert max-w-none prose-a:text-gold prose-headings:text-white prose-li:text-zinc-400 prose-p:text-zinc-400';
